import React, { useEffect, useRef, useState } from 'react'
import './videos-section.scss'
import videos, { TVideoInfo } from './data-source'
import ReactPlayer from 'react-player/youtube'
import { LOCALE_AT } from '@/constants/activity-constants'
import { triggerTageo } from '@/utils/tagging-util'
const $APRENDE = LOCALE_AT.PARAGUAY ? 'APRENDÉ' : 'APRENDE'
const $PUEDES = LOCALE_AT.PARAGUAY ? 'PODES' : 'PUEDES'
const updateScriptYoutubeType = async () => {
  // WAIT ... hammer time
  let interaval = setInterval(() => {
    // FIND THE YOUTUBE API
    const tag: HTMLScriptElement = document.querySelector(
      "script[src='https://www.youtube.com/iframe_api']"
    )!
    if (!tag) return
    const parent: HTMLElement = tag.parentElement!

    // remove
    tag.remove()
    // change type
    tag.type = 'text/javascript' // text/plain
    // append again
    parent.appendChild(tag)
    clearInterval(interaval)
    //
  }, 10)
}
function VideoItem({
  video,
  onVideoClick,
}: {
  video: TVideoInfo
  onVideoClick: () => void
}) {
  const isAvaible = video.avaibleDate <= Date.now()
  const onClickHandler = () => {
    // go to video
    if (isAvaible) {
      onVideoClick()
      //
    }
  }
  const avaibleText = isAvaible ? (
    <a className="--linked" onClick={onClickHandler}>
      Míralo ahora <span className="img-icon-arrow-right" />{' '}
    </a>
  ) : (
    <a>
      <span className="img-icon-lock" /> Disponible {video.avaibleText}
    </a>
  )
  return (
    <figure>
      <div
        className={'img-wrapper ' + (isAvaible ? '--active' : '')}
        title={isAvaible ? 'mirar ' + video.name : 'Próximamente ' + video.name}
        role="button"
        onClick={onClickHandler}
      >
        <img
          src={video.image}
          alt={video.name}
          title={video.name}
          width={201}
          height={112}
        />
      </div>
      <figcaption>
        <h5 className="title">{video.name}</h5>
        {avaibleText}
      </figcaption>
      <div className="person-tag">{video.personName}</div>
    </figure>
  )
}
function ItemSliderVideos({
  onVideoClick,
}: {
  onVideoClick: (item: TVideoInfo) => void
}) {
  return (
    <div className="f-videos-section__slider">
      <div className="f-videos-section__slider__wrapper">
        {videos.map(video => {
          return (
            <VideoItem
              key={video.name}
              video={video}
              onVideoClick={() => {
                triggerTageo('8A', {
                  label: 'play',
                  video_name: video.name,
                  location:
                    window.location.host +
                    window.location.pathname +
                    '#video-expertas',
                })
                onVideoClick(video)
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

function EmbedVideoPlayer({
  video,
  onClose,
}: {
  video: TVideoInfo
  onClose: () => void
}) {
  const refPlayer = useRef(null)
  const storeDataTemp = {
    playedSeconds: 0,
  }
  const onPlayHandler = () => {
    // TAG    triggerTageo('18A', { label: 'play' })
  }
  const onFinishHandler = () => {
    // TAG    triggerTageo('18A', { label: 'play' })
  }
  const onProgressHandler = (progress: { playedSeconds: number }) => {
    storeDataTemp.playedSeconds = progress.playedSeconds
  }

  const handlerClose = () => {
    onClose()
  }
  useEffect(() => {
    updateScriptYoutubeType()
  }, [])
  return (
    <div className="f-videos-section__popup">
      <button
        className="button-close icon2-close"
        onClick={() => {
          handlerClose()
        }}
      ></button>
      <ReactPlayer
        ref={refPlayer}
        url={video.url} //'https://www.youtube.com/watch?v=dT4c-a6jToE&ab_channel=Nosotras'
        className="video-container"
        volume={0.6}
        controls={true}
        playing={true}
        onEnded={onFinishHandler}
        onPlay={onPlayHandler}
        onProgress={onProgressHandler}
      />
    </div>
  )
}
export default function VideosSection({ id }: { id: string }) {
  const [currentVideo, setCurrentVideo] = useState<TVideoInfo | null>(null)
  const handlerOnVideoCLick = (video: TVideoInfo) => {
    setCurrentVideo(video)
  }

  return (
    <section id={id} className="f-videos-section">
      {currentVideo && (
        <EmbedVideoPlayer
          video={currentVideo}
          onClose={() => {
            setCurrentVideo(null)
          }}
        />
      )}
      <h2 className="title">
        <b>El 80% somos observadores*,</b>
        <br />
        <span className="highlighted">
          {$APRENDE} JUNTO A NUESTRA EXPERTA
        </span>{' '}
        CÓMO {$PUEDES} ACTUAR ANTE UNA SITUACIÓN DE BULLYING
      </h2>
      <h3 className="subtitle">PROGRAMACIÓN TODO EL MES</h3>
      <ItemSliderVideos onVideoClick={handlerOnVideoCLick} />
    </section>
  )
}
